import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
declare var cordova: any;
declare var navigator: any;
declare var StatusBar: any;
declare var FirebasePlugin: any;

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

let onDeviceReady = () => {
    platformBrowserDynamic().bootstrapModule(AppModule);
    navigator.splashscreen.hide();

    /*
    FirebasePlugin.onMessageReceived(function(message) {
        try{
            
            //incrementBadgeNumber();
            console.log("onMessageReceived");
            console.dir(message);
            if(message.messageType === "notification"){
                handleNotificationMessage(message);
            }else{
                handleDataMessage(message);
            }
        }catch(e){
            //logError("Exception in onMessageReceived callback: "+e.message);
        }

    }, function(error) {
        //logError("Failed receiving FirebasePlugin message", error);
    });
    */

    

    checkNotificationPermission(false); // Check permission then get token
    
    clearBadgeNumber();

    if (cordova.platformId === "ios") {
      StatusBar.overlaysWebView(false);
      StatusBar.styleDefault();
      StatusBar.backgroundColorByHexString('#FFFFFF');
      StatusBar.styleDefault();

      initIos();
    }
    else {
      initAndroid();
    }

    window.open = cordova.InAppBrowser.open;
    
};



document.addEventListener('deviceready', onDeviceReady, false);




let initIos = function(){
  FirebasePlugin.onApnsTokenReceived(function(token){
      //log("APNS token received: " + token)
  }, function(error) {
      //logError("Failed to receive APNS token", error);
  });
};

let initAndroid = function() {

  // Define custom  channel - all keys are except 'id' are optional.
  var customChannel  = {
      // channel ID - must be unique per app package
      id: "jetsinif",

      // Channel name. Default: empty string
      name: "Jetsınıf",

      //The sound to play once a push comes. Default value: 'default'
      //Values allowed:
      //'default' - plays the default notification sound
      //'ringtone' - plays the currently set ringtone
      //filename - the filename of the sound file located in '/res/raw' without file extension (mysound.mp3 -> mysound)
      sound: "default",

      //Vibrate on new notification. Default value: true
      //Possible values:
      //Boolean - vibrate or not
      //Array - vibration pattern - e.g. [500, 200, 500] - milliseconds vibrate, milliseconds pause, vibrate, pause, etc.
      vibration: [300, 200, 300],

      // Whether to blink the LED
      light: true,

      //LED color in ARGB format - this example BLUE color. If set to -1, light color will be default. Default value: -1.
      lightColor: "0xFF0000FF",

      //Importance - integer from 0 to 4. Default value: 3
      //0 - none - no sound, does not show in the shade
      //1 - min - no sound, only shows in the shade, below the fold
      //2 - low - no sound, shows in the shade, and potentially in the status bar
      //3 - default - shows everywhere, makes noise, but does not visually intrude
      //4 - high - shows everywhere, makes noise and peeks
      importance: 4,

      //Show badge over app icon when non handled pushes are present. Default value: true
      badge: true,

      //Show message on locked screen. Default value: 1
      //Possible values (default 1):
      //-1 - secret - Do not reveal any part of the notification on a secure lockscreen.
      //0 - private - Show the notification on all lockscreens, but conceal sensitive or private information on secure lockscreens.
      //1 - public - Show the notification in its entirety on all lockscreens.
      visibility: 1
  }

  FirebasePlugin.createChannel(customChannel,
      function() {
          //log("Created custom channel: "+customChannel.id);
          FirebasePlugin.listChannels(
              function(channels) {
                  if(typeof channels == "undefined") return;
                  for(var i=0;i<channels.length;i++) {
                      //log("Channel id=" + channels[i].id + "; name=" + channels[i].name);
                  }
              },
              function(error) {
                  //logError('List channels error: ' + error);
              }
          );
      },
      function(error) {
          //logError("Create channel error", error);
      }
  );

};


// Notifications
var checkNotificationPermission = function(requested){
  FirebasePlugin.hasPermission(function(hasPermission){
      if(hasPermission){
          //log("Remote notifications permission granted");
          // Granted
          //getToken();
      }else if(!requested){
          // Request permission
          //log("Requesting remote notifications permission");
          FirebasePlugin.grantPermission(checkNotificationPermission.bind(this, true));
      }else{
          // Denied
          //logError("Notifications won't be shown as permission is denied");
      }
  });
};

var checkAutoInit = function(){
  FirebasePlugin.isAutoInitEnabled(function(enabled){
      
  }, function(error) {
      //logError("Failed to check auto init", error);
  });
};

var enableAutoInit = function(){
  FirebasePlugin.setAutoInitEnabled(true, function(){
      //log("Enabled auto init");
      checkAutoInit();
  }, function(error) {
      //logError("Failed to enable auto init", error);
  });
};

var disableAutoInit = function(){
  FirebasePlugin.setAutoInitEnabled(false, function(){
      //log("Disabled auto init");
      checkAutoInit();
  }, function(error) {
      //logError("Failed to disable auto init", error);
  });
};

var getID = function(){
  FirebasePlugin.getId(function(id){
      //log("Got FCM ID: " + id)
  }, function(error) {
      //logError("Failed to get FCM ID", error);
  });
};

var getToken = function(){
  FirebasePlugin.getToken(function(token){
      //log("Got FCM token: " + token)
      return token;
  }, function(error) {
      //logError("Failed to get FCM token", error);
  });
};

var getAPNSToken = function(){
  FirebasePlugin.getAPNSToken(function(token){
      //log("Got APNS token: " + token)
  }, function(error) {
      //logError("Failed to get APNS token", error);
  });
};

var handleNotificationMessage = function(message){

  var title;
  if(message.title){
      title = message.title;
  }else if(message.notification && message.notification.title){
      title = message.notification.title;
  }else if(message.aps && message.aps.alert && message.aps.alert.title){
      title = message.aps.alert.title;
  }

  var body;
  if(message.body){
      body = message.body;
  }else if(message.notification && message.notification.body){
      body = message.notification.body;
  }else if(message.aps && message.aps.alert && message.aps.alert.body){
      body = message.aps.alert.body;
  }

  var msg = "Notification message received";
  if(message.tap){
      msg += " (tapped in " + message.tap + ")";
  }
  if(title){
      msg += '; title='+title;
  }
  if(body){
      msg += '; body='+body;
  }
  msg  += ": "+ JSON.stringify(message);
  //log(msg);
};

var handleDataMessage = function(message){
  //log("Data message received: " + JSON.stringify(message));
};


function clearNotifications(){
  FirebasePlugin.clearAllNotifications(function(){
      //log("Cleared all notifications");
  },function(error){
      //logError("Failed to clear notifications", error);
  });
}

function subscribe(){
  FirebasePlugin.subscribe("my_topic", function(){
      //log("Subscribed to topic");
  },function(error){
      //logError("Failed to subscribe to topic", error);
  });
}

function unsubscribe(){
  FirebasePlugin.unsubscribe("my_topic", function(){
      //log("Unsubscribed from topic");
  },function(error){
      //logError("Failed to unsubscribe from topic", error);
  });
}

function getBadgeNumber(){
  FirebasePlugin.getBadgeNumber(function(number){
      //log("Current badge number: "+number);
  },function(error){
      //logError("Failed to get badge number", error);
  });
}

function incrementBadgeNumber(){
  FirebasePlugin.getBadgeNumber(function(current){
      var number = current+1;
      FirebasePlugin.setBadgeNumber(number, function(){
          //log("Set badge number to: "+number);
      },function(error){
          //logError("Failed to set badge number", error);
      });
  },function(error){
      //logError("Failed to get badge number", error);
  });
}

function clearBadgeNumber(){
  FirebasePlugin.setBadgeNumber(0, function(){
      //log("Cleared badge number");
  },function(error){
      //logError("Failed to clear badge number", error);
  });
}

function unregister(){
  FirebasePlugin.unregister(function(){
      //log("Unregistered from Firebase");
  },function(error){
      //logError("Failed to unregister from Firebase", error);
  });
}

